export var initSubSettings = function (column) {
    column.getElement().querySelectorAll('.ac-column-setting--filter,.ac-column-setting--sort,.ac-column-setting--edit').forEach(function (setting) {
        new SubsettingSetting(setting);
    });
};
var SubsettingSetting = /** @class */ (function () {
    function SubsettingSetting(element) {
        this.element = element;
        this.inputs = element.querySelectorAll('.ac-setting-input input[type="radio"]');
        this.subFields = element.querySelectorAll('.ac-column-setting');
        this.initState();
        this.initEvents();
    }
    SubsettingSetting.prototype.initEvents = function () {
        var _this = this;
        this.inputs.forEach(function (el) {
            el.addEventListener('change', function () { return _this.initState(); });
        });
    };
    SubsettingSetting.prototype.initState = function () {
        this.isOptionEnabled()
            ? this.subFields.forEach(function (el) { return el.style.display = 'table'; })
            : this.subFields.forEach(function (el) { return el.style.display = 'none'; });
    };
    SubsettingSetting.prototype.isOptionEnabled = function () {
        var checked = Array.from(this.inputs).filter(function (input) {
            return input.checked;
        });
        return checked.length ? checked[0].value === 'on' : false;
    };
    return SubsettingSetting;
}());
